import script from "./council-allocation-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./council-allocation-modal.vue?vue&type=script&setup=true&lang=ts"

import "./council-allocation-modal.vue?vue&type=style&index=0&id=df0e9a42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0e9a42"]])

export default __exports__